var scope_0 = require('/opt/build/repo/frontend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/683027457502de041576510817a58138.js').default;
var scope_1 = require('/opt/build/repo/frontend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d412d5f13eb24cc5b418cbbdacfd90cf.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    